export default __webpack_public_path__ + "static/media/14.ec9d3c43.png";